export default "__VITE_ASSET__2fad8dad__"